import { trace } from '@opentelemetry/api';

export function recordReactError(error: Error, info?: { componentStack?: string }) {
  console.log('recordReactError called with error:', error, info);
  const tracer = trace.getTracer('react-error-boundary');
  const span = tracer.startSpan('react.error', {
    attributes: {
      'error.message': error?.message,
      'error.name': error?.name,
      'error.stack': error?.stack,
    },
  });

  if (info?.componentStack) {
    span.setAttribute('react.component_stack', info.componentStack);
  }

  span.recordException(error);
  span.end();
}
